<template>
    <div>
        <base-header class="pb-6"></base-header>
        <div class="container-fluid mt--6">
            <div class="card">
                <div class="card-header border-0">
                    <div class="row">
                        <div class="col-sm-12 col-md-8">
                        <h3 class="mb-0">Evaluaciones</h3>
                        </div>
                        <div class="col-sm-12 col-md-4 text-right">
                            <button
                            type="button"
                            class="btn base-button btn-icon btn-fab btn-primary btn-sm"
                            role="button"
                            aria-pressed="true"
                            @click="Tasks"
                        >
                        <span class="btn-inner--icon"><i class="fas fa-user-edit"></i></span>
                        <span class="btn-inner--text">To - Do</span>
                        </button>
                        </div>
                    </div>
                </div>
                <div class="row starter-page">
                    <div class="container-fluid">
                        <el-table
                        class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        row-key="id"
                        :data="evaluations"
                        >
                        <el-table-column
                        label="Evaluación"
                        prop="uuid"
                        min-width="200px"
                        sortable
                        >
                        <template v-slot="{row}">#{{ row.uuid }}</template>
                        </el-table-column>
                        <el-table-column label="Fecha" prop="created_at"  min-width="200px" sortable>
                            <template v-slot="{row}">{{ row.created_at | date}}</template>
                        </el-table-column>
                        <el-table-column label="Puntos" prop="points"  min-width="200px" sortable>
                            <template v-slot="{row}">{{ row.points }} PTS</template>
                        </el-table-column>
                        <el-table-column label="Accion" prop="id"  min-width="200px" sortable>
                           <template v-slot="{row}">
                            <base-button
                            type="primary"
                            @click="showEvaluation(row.id)"
                            >
                            <i class="far fa-file-pdf"></i> Ver
                            </base-button>
                            </template>
                        </el-table-column>    
                        </el-table>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Dropdown, DropdownItem, DropdownMenu, Table, TableColumn, Tooltip} from "element-ui";
import axios from "axios";
import moment from "moment";
export default {
    name: "Evaluaciones",
    components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    },
    data() {
        return {
        evaluations: [],
        };
    },
    created() {
    this.getEvaluations()
    },
    methods: {
        getEvaluations(){
            axios.get('/evaluaciones').then((response => {
                this.evaluations = response.data
            }))
        },
        showEvaluation(id){
            this.$router.push({ name: 'evaluacion_categorias', params: { id: id } })
        },
        Tasks(){
            this.$router.push({ name: 'evaluaciones_tareas' })
        }
    },
    filters:{
        date: function(value){
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY')
            }
        }
    }
}
</script>
<style lang="scss" scoped>

</style>